export default __webpack_public_path__ + "static/media/adventour-home.b80a109f.JPG";